// extracted by css-extract-rspack-plugin
export default {"debugResponseTimeIndicator":"debugResponseTimeIndicator-fgQAAT"};